import { useRouter } from 'next/router';
import React from 'react';

export default function BackHeader() {
  const router = useRouter();

  return (
    <div className="navbar sticky top-16 z-40 bg-base-300 text-base-content shadow-lg">
      <div className="flex-none">
        <button
          onClick={() => router.push('/app')}
          className="btn btn-ghost btn-square"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            className="inline-block h-6 w-6 stroke-current"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            ></path>
          </svg>
        </button>
        <div className="align-center mx-2 flex flex-1 px-2">
          <div className="break-all font-bold sm:max-w-sm md:max-w-md">
            My Account
          </div>
        </div>
      </div>
      <div className="flex-none"></div>
    </div>
  );
}
